// extracted by mini-css-extract-plugin
module.exports = {"header":"simple-header-section_header__M56cT","logoItem":"simple-header-section_logoItem__Ekh6W"};